module.exports = __webpack_public_path__ + "static/helsehjulet_logo-163ecc6f492c283b76f1a3134abd731a.svg";